<template>
  <div>
    <booking-menu-with-budget-header :title="$t('booking.flight.title')" budget-type="flight" />

    <v-row />

    <booking-flight-data-table />
  </div>
</template>

<script>
import BookingFlightDataTable from "../../components/Booking/BookingFlightDataTable.vue";
import BookingMenuWithBudgetHeader from "../../components/Booking/BookingMenuWithBudgetHeader";

export default {
  name: "BookingFlightView",
  components: { BookingMenuWithBudgetHeader, BookingFlightDataTable },
  data: () => ({
    search: ""
  }),
  computed: {},
  methods: {},
  created() {}
};
</script>

<style scoped></style>
